import { GraphQL } from "@rpi/openapi-api";

export const CANCELLABLE_STATUSES: GraphQL.OrderStatus[] = [
  GraphQL.OrderStatus.Created,
  GraphQL.OrderStatus.PricingCompleted,
  GraphQL.OrderStatus.Received,
  GraphQL.OrderStatus.ReceivedOverLimit,
  GraphQL.OrderStatus.WaitingInHoldingBin,
  GraphQL.OrderStatus.WaitingForSubmission,
  GraphQL.OrderStatus.Submitting,
  GraphQL.OrderStatus.Submitted,
  GraphQL.OrderStatus.ReceivedByPrinter,
  GraphQL.OrderStatus.InProduction,
  GraphQL.OrderStatus.ReadyToShip,
];

export function canCancelOrder(order: { status?: GraphQL.OrderStatus | null }): boolean {
  return order.status ? CANCELLABLE_STATUSES.includes(order.status) : false;
}

// Statuses an order can be redriven from. The backend enforces the full
// eligibility (never submitted, paid, stale enough) and surfaces a reason when
// it rejects; this is just the coarse status gate for the menu item.
export const REDRIVABLE_STATUSES: GraphQL.OrderStatus[] = [
  GraphQL.OrderStatus.WaitingForSubmission,
  GraphQL.OrderStatus.Exception,
];

export function canRedriveOrder(status: GraphQL.OrderStatus | null | undefined): boolean {
  return status ? REDRIVABLE_STATUSES.includes(status) : false;
}
